'use client';
import React, { useEffect } from 'react';
import { useIsomorphicLayoutEffect } from '@financial/common-hooks';
import { LOG_MODE } from '../constants/global.mjs';
import { ModalProvider } from './ModalContext.mjs';
import RenderProvider from './RenderProvider.mjs';
import { ToastProvider } from './ToastContext.mjs';
import { injectPackageVersion } from '../utils/env.mjs';

function DefignProvider(_ref) {
  let {
    children,
    toast = {},
    logMode = LOG_MODE.PRODUCTION,
    customColor
  } = _ref;
  useEffect(() => {
    injectPackageVersion();
  }, []);
  useIsomorphicLayoutEffect(() => {
    if (customColor) {
      document.documentElement.style.setProperty('--custom-default-color', customColor);
    }
  }, [customColor]);
  return /*#__PURE__*/React.createElement(RenderProvider, {
    logMode: logMode
  }, /*#__PURE__*/React.createElement(ToastProvider, {
    ...toast
  }, /*#__PURE__*/React.createElement(ModalProvider, null, children)));
}

export { DefignProvider as default };
